import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { CompoundDetails, CompoundListingModal, CompoundDetail } from "./types";

const initialState: CompoundListingModal = {
  compoundListing: [],

  compoundDetail: {
    _id: "",
    compoundType: "",
    pageTitle: "",
    compound: [],
    compoundIds: [],
    description: "",
    status: "",
    createdAt: "",
    updatedAt: "",
    fallbackTitle: "",
  },
};

const compoundListingSlice = createSlice({
  name: "compoundListing",
  initialState,
  reducers: {
    setCompoundListingData: (
      state: CompoundListingModal,
      action: PayloadAction<CompoundDetails[]>,
    ) => {
      state.compoundListing = [...action.payload];
    },

    resetCompoundListingData: (state: CompoundListingModal) => {
      state.compoundListing = initialState.compoundListing;
    },

    setCompoundDetail: (
      state: CompoundListingModal,
      action: PayloadAction<CompoundDetail>,
    ) => {
      state.compoundDetail = action.payload;
    },

    resetCompoundDetail: (state: CompoundListingModal) => {
      state.compoundDetail = initialState.compoundDetail;
    },
  },
});

export const {
  setCompoundDetail,
  setCompoundListingData,
  resetCompoundListingData,
  resetCompoundDetail,
} = compoundListingSlice.actions;

export default compoundListingSlice.reducer;
